module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/36_10541418b07ccb1038c1980c2f22d1e1.jpg";